<template>
  <b-card-code title="Basic">
    <div class="demo-vertical-spacing">
      <!-- basic search -->
      <b-input-group>
        <b-input-group-prepend is-text>
          <!-- <feather-icon icon="SearchIcon" /> -->
          <font-awesome-icon
            :icon="['fas', 'search']"
          />
        </b-input-group-prepend>
        <b-form-input placeholder="Search" />
      </b-input-group>

      <!-- password -->
      <b-form-group>
        <label for="basic-password">Password</label>
        <b-input-group>
          <b-form-input
            id="basic-password"
            :type="passwordFieldType"
            placeholder="Your Password"
          />
          <b-input-group-append is-text>
            <feather-icon
              :icon="passwordToggleIcon"
              class="cursor-pointer"
              @click="togglePasswordVisibility"
            />
            <!-- <font-awesome-icon
              :icon="awesomeTogglePasswordIcon"
              class="cursor-pointer"
              @click="awesomeTogglePasswordVisibility"
            /> -->
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <!-- with prop prepend  -->
      <b-input-group prepend="@">
        <b-form-input placeholder="Username" />
      </b-input-group>

      <!-- with prop append -->
      <b-input-group append="@example.com">
        <b-form-input placeholder="Recipient's username" />
      </b-input-group>

      <b-input-group prepend="https://example.com/users/">
        <b-form-input />
      </b-input-group>

      <!-- append and pepend -->
      <b-input-group
        prepend="$"
        append=".00"
      >
        <b-form-input placeholder="100" />
      </b-input-group>

      <!-- textarea -->
      <b-input-group prepend="With textarea">
        <b-form-textarea />
      </b-input-group>
      <!-- with prop prepend  -->
      <!-- <b-input-group prepend="@" class="form-label-group">
        <b-form-input
          id="floating-username"
          placeholder="Username"
        />
        <label for="floating-username">Username</label>
      </b-input-group> -->

      <b-row>
        <!-- checkbox -->
        <b-col md="6">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend is-text>
                <b-form-checkbox
                  plain
                  name="checkbox-input"
                />
              </b-input-group-prepend>
              <b-form-input placeholder="Message" />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- radio -->
        <b-col md="6">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend is-text>
                <b-form-radio
                  v-model="radio1"
                  value="radio2"
                  plain
                  name="radio-input1"
                />
              </b-input-group-prepend>
              <b-form-input placeholder="Message" />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <template #code>
      {{ codeBasic }}
    </template>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BRow, BCol, BInputGroup, BFormInput, BInputGroupPrepend, BInputGroupAppend, BFormGroup, BFormTextarea, BFormCheckbox, BFormRadio,
} from 'bootstrap-vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { codeBasic } from './code'

export default {
  components: {
    BRow,
    BCol,

    BCardCode,
    BFormTextarea,
    BInputGroup,
    BFormGroup,
    BFormInput,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormCheckbox,
    BFormRadio,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      codeBasic,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    // awesomePasswordToggleIcon() {
    //   return this.passwordFieldType === 'password' ? 'fas-eye' : 'fas-eye-slash'
    // },
  },
}
</script>
